/*! @azure/msal-common v15.7.1 2025-06-18 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.7.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
